import React from 'react';

const LinkedInThankYou = () => {
  return (
    <div
      style={{
        fontFamily: 'Arial, sans-serif',
        textAlign: 'center',
        paddingTop: '100px',
        backgroundColor: '#f5f5f5',
        height: '100vh',
      }}
    >
      <div style={{ fontSize: '24px', color: '#2e3192' }}>
        <p>✅ Thank you for connecting your LinkedIn account!</p>
        <p>You may now close this tab and return to the application.</p>
      </div>
    </div>
  );
};

export default LinkedInThankYou;
